import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { UserRequestModel, UserRequestDetailResponse } from "@/core/models/user-request.model";
import { ApiResponse } from "@/core/models/response.model";

interface _UserRequestGetParams {
    search?: string;
    userId?: string;
    status?: string;
    requestType?: string;
}

interface UserRequestEnumResponse {
    userRequestType: Array<{id: number, name: string, description: string}>;
    userRequestStatus: Array<{id: number, name: string, description: string}>;
}

@injectable()
export class UserRequestRepo extends TableRepo<UserRequestModel> {
    constructor() {
        super("/api/UserRequest");
    }

    async getData(index: number, params: _UserRequestGetParams, pageSize = 10): Promise<ApiPage<UserRequestModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async getDetail(id: string): Promise<UserRequestDetailResponse | null> {
        try {
            const response = await this.apiRepo.get<UserRequestDetailResponse>(
                `${this.basepath}/detail`,
                { id: id }
            );
            if (response?.code === "00") {
                return response.result;
            }
            return null;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async getTimeline(id: string): Promise<UserRequestDetailResponse["statusHistory"] | null> {
        try {
            const response = await this.apiRepo.get<{data: UserRequestDetailResponse["statusHistory"]}>(
                `${this.basepath}/timeline/${id}`
            );
            if (response?.code === "00") {
                return response.result.data;
            }
            return null;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async getEnums(): Promise<UserRequestEnumResponse | null> {
        try {
            const response = await this.apiRepo.get<UserRequestEnumResponse>("/api/enum/get-all");
            if (response?.code === "00") {
                return response.result;
            }
            return null;
        } catch (err) {
            console.log(err);
            return null;
        }
    }
}